// --- カスタムボタンのスクロール制御 ---
    const scrollButtons = document.querySelectorAll('.product-lineup-button-group a');

    scrollButtons.forEach(button => {
        button.addEventListener('click', function(e) {
            const href = this.getAttribute('href');
            if (href && href.startsWith('#')) {
                e.preventDefault(); 

                const targetElement = document.querySelector(href);
                if (targetElement) {
                    targetElement.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                }
            }
        });
    });

document.addEventListener('DOMContentLoaded', function() {
    
    // --- TOP画像のロード時アニメーション ---
    const topImage = document.querySelector('.blur-effect');
    if (topImage) {
        const activateTopImage = () => {
             setTimeout(() => {
                topImage.classList.add('is-loaded');
            }, 100);
        };
        
        topImage.onload = activateTopImage;
        if (topImage.complete) {
            activateTopImage();
        }
    }


    // --- スクロール連動アニメーション ---
        const fadeUpElements = document.querySelectorAll('.animate-fade-up');
    
    const observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: 0.1 
    };
    
    const observerCallback = (entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                observer.unobserve(entry.target);
            }
        });
    };
    
    const observer = new IntersectionObserver(observerCallback, observerOptions);
    
    fadeUpElements.forEach(element => {
        observer.observe(element);
    });
});